import { render } from "./ProductSelectionProductsSelectionItem.vue?vue&type=template&id=d77ab792&scoped=true&ts=true"
import script from "./ProductSelectionProductsSelectionItem.vue?vue&type=script&lang=ts"
export * from "./ProductSelectionProductsSelectionItem.vue?vue&type=script&lang=ts"

import "./ProductSelectionProductsSelectionItem.vue?vue&type=style&index=0&id=d77ab792&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d77ab792"]])

export default __exports__